import { createActionsGroup } from 'utils/redux-utils'

export const getPromoProduct = createActionsGroup('GET_PROMO_PRODUCT')
